export default "__VITE_ASSET__274d4c55__"